import Map from '@rio-cloud/rio-uikit/Map';
import Marker from '@rio-cloud/rio-uikit/Marker';
import SingleMapMarker from '@rio-cloud/rio-uikit/SingleMapMarker';
import { Link } from 'react-router-dom';

import type { ChargingSessionType } from '@/api/schema';
import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import { t } from '@/lib/utils';

export type ChargingStationTabProps = {
    state?: ChargingSessionType;
    formatter?: (code: string) => string | undefined;
    credentials: any;
    location?: { lat: number; lng: number; zoomLevel: number };
    linkToLiveMonitor?: string | null;
};

export const ChargingStationTab = ({
    state,
    formatter,
    credentials,
    location,
    linkToLiveMonitor,
}: ChargingStationTabProps) => {
    const handleOpenFleetMonitorClick = () => {
        trackCustomEvent(
            'open_fleet_monitor_link',
            {
                trigger: 'click',
                flow_name: 'charging_activity',
                element_name: 'fleet_monitor_button_for_charging_station',
            },
            createDebugConfig()
        );
    };

    return (
        <>
            <div className='align-items-center divider-y display-flex flex-column gap-0'>
                <div className='width-100pct'>
                    <div className='padding-y-15 display-flex justify-content-between'>
                        <span className='text-color-gray'>{t('chargingSessions.chargePoint')}</span>
                        <span>{state?.chargingPoint?.name}</span>
                    </div>
                </div>
                {state?.chargingPoint?.operatorName && (
                    <div className='width-100pct'>
                        <div className='padding-y-15 display-flex justify-content-between'>
                            <span className='text-color-gray'>{t('chargingSessions.operator')}</span>
                            <span>{state?.chargingPoint?.operatorName}</span>
                        </div>
                    </div>
                )}
                <div className='width-100pct'>
                    <div className='padding-y-15 display-flex justify-content-between'>
                        <span className='text-color-gray'>{t('general.address')}</span>
                        <span>{state?.chargingPoint?.address}</span>
                    </div>
                </div>
                <div className='width-100pct'>
                    <div className='padding-y-15 display-flex justify-content-between'>
                        <span className='text-color-gray'>{t('general.zipCode')}</span>
                        <span>{state?.chargingPoint?.zip}</span>
                    </div>
                </div>
                <div className='width-100pct'>
                    <div className='padding-y-15 display-flex justify-content-between'>
                        <span className='text-color-gray'>{t('general.city')}</span>
                        <span>{state?.chargingPoint?.city}</span>
                    </div>
                </div>
                {state?.chargingPoint?.countryCode && formatter && (
                    <div className='width-100pct'>
                        <div className='padding-y-15 display-flex justify-content-between'>
                            <span className='text-color-gray'>{t('general.country')}</span>
                            <span>{formatter(state?.chargingPoint?.countryCode)}</span>
                        </div>
                    </div>
                )}
            </div>
            {credentials.success && location && (
                <div className='margin-top-10'>
                    <Map credentials={credentials.data} center={location} zoom={location.zoomLevel} height={107}>
                        <Marker
                            position={location}
                            icon={
                                <div className='height-5 width-5'>
                                    <SingleMapMarker
                                        iconNames={['filling-e-station']}
                                        markerColor='bg-map-marker-poi'
                                        fixed
                                    />
                                </div>
                            }
                        />
                    </Map>
                </div>
            )}

            {linkToLiveMonitor && (
                <Link
                    className='margin-top-10 display-block'
                    to={linkToLiveMonitor}
                    target='_blank'
                    onClick={handleOpenFleetMonitorClick}
                >
                    {t('general.button.openInFleetMonitor')}
                </Link>
            )}
        </>
    );
};
